import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import tokenConstant from "service/constant/tokenConstant";

export function PrivateRoute({ children }: any) {
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem(tokenConstant.ACCESSTOKEN),
  );

  useEffect(() => {
    setAccessToken(localStorage.getItem(tokenConstant.ACCESSTOKEN));
  }, []);

  return accessToken ? children : <Navigate to="/" />;
}
